import { InputSkeleton } from '@/_components';
import { CardContainer, FormLayout, SectionHeadingSkeleton } from '@/_containers';
import AddressFormLoading from '@/_containers/inputs/address/loading';
import PhoneNumberLoading from '@/_containers/inputs/phone-number/loading';

export default function Loading() {
  return (
    <>
      <CardContainer>
        <SectionHeadingSkeleton />

        <FormLayout>
          <InputSkeleton className="col-span-12 sm:col-span-6" />
          <InputSkeleton className="col-span-12 sm:col-span-6" />
        </FormLayout>
      </CardContainer>

      <CardContainer>
        <SectionHeadingSkeleton />
        <FormLayout>
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />

          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-3" />
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-3" />
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-3" />
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-3" />

          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-6" />
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-6" />
        </FormLayout>
      </CardContainer>

      <CardContainer>
        <SectionHeadingSkeleton />

        <AddressFormLoading />
      </CardContainer>

      <CardContainer>
        <SectionHeadingSkeleton />

        <AddressFormLoading />
      </CardContainer>

      <div className="flex flex-col gap-4 lg:flex-row">
        <CardContainer className="flex-1">
          {/* // ken asked for it */}
          <SectionHeadingSkeleton />
          <PhoneNumberLoading />
        </CardContainer>
        <CardContainer className="flex-1">
          {/* // ken asked for it */}
          <SectionHeadingSkeleton />
          <PhoneNumberLoading />
        </CardContainer>
      </div>
    </>
  );
}
